import React from 'react';
import { Button, Icon, Modal } from 'antd';
import { useAccountOrMembershipRequiredModalContext } from './contexts/AccountOrMembershipRequiredModalContext';
import RegistrationModalLinks from '../AnonymousHeader/RegistrationModal/RegistrationModalLinks/RegistrationModalLinks';
import WrappedRegistrationForm from '../AnonymousHeader/RegistrationModal/RegistrationForm/RegistrationForm';
import { RegistrationTypes } from '../AnonymousHeader/RegistrationModal/RegistrationEnums';
import delay from '../../../util/delay';
import { useCommunities } from '../../Communities/containers/communitiesDataStore';
import { useUser } from '../../User/containers/UserDataStore';
import paths from '../../../paths';
import './accountOrMembershipRequiredModal.less';
import { getAccountRequiredModalTitle } from '../util';
import { Translate } from '@above-the-treeline/localization';
import RegistrationDataStore from '../../Registration/containers/RegistrationDataStore';

export default function AccountOrMembershipRequiredModal() {
	const {
		isVisible,
		setIsVisible,
		type,
		setType,
		community,
	} = useAccountOrMembershipRequiredModalContext();
	const isAnonymous = useUser().isAnonymous();
	const { joinCommunity } = useCommunities();

	const [isLoading, setIsLoading] = React.useState(false);

	const handleCancel = async () => {
		setIsVisible(false);
		if (isAnonymous) {
			await delay(500);
			setType(RegistrationTypes.SignUp);
			window.location.pathname.includes('/list/') && returnHome();
		}
	};

	const returnHome = () => (window.location.href = paths.home());

	const getMembershipRequiredModalContents = () => {
		return (
			<>
				<div className="non-member-modal-message">
					<Icon style={{ color: '#fc601f' }} type="info-circle" />
					<Translate
						id="you_must_be_a_member_of_the_x_community"
						data={{ name: community.name }}
					/>
				</div>
				<div className="non-member-modal-buttons">
					<Button key="cancel" onClick={handleCancel}>
						<Translate id="cancel" />
					</Button>
					<Button
						key="submit"
						type="primary"
						className="orange-ant-btn"
						onClick={() => joinCommunity(community.id)}>
						<Translate id="join_community" />
					</Button>
				</div>
			</>
		);
	};

	const getAccountRequiredModalContents = () => {
		return (
			<>
				<div className="modal-message">
					<Translate id={getAccountRequiredModalTitle(type)} />
				</div>
				<RegistrationDataStore>
					<WrappedRegistrationForm
						type={type}
						isLoading={isLoading}
						setIsLoading={setIsLoading}
					/>
				</RegistrationDataStore>
				{!isLoading && (
					<RegistrationModalLinks setType={setType} type={type} />
				)}
			</>
		);
	};

	return (
		<Modal
			visible={isVisible}
			onCancel={handleCancel}
			footer={null}
			maskStyle={{ zIndex: 1001 }}
			wrapClassName="registration-modal account-required-modal">
			{isAnonymous
				? getAccountRequiredModalContents()
				: getMembershipRequiredModalContents()}
		</Modal>
	);
}
